import { Component, Input } from '@angular/core';
import { ScreeningAdditionalData } from 'src/app/models/screeningInvite';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-income-verification-manager',
  templateUrl: './income-verification-manager.component.html',
  styleUrls: ['./income-verification-manager.component.less']
})
export class IncomeVerificationManagerComponent {

  ngOnInit(): void {
    this.appData.GetIncomeVerificationData(this.pkg.searchEntryId);
  }
  @Input() pkg : ScreeningAdditionalData;

  constructor(public appData : ApplicantDataService, public auth : AuthService){}

}
